import { jsx as _jsx } from "react/jsx-runtime";
import { TitleSize, Widget, WidgetSize, WidgetVariant } from '@common/widgets/widget/widget';
export function BaseConstituentWidget(props) {
    return (_jsx(Widget, { widgetSize: WidgetSize.Medium, titleSize: TitleSize.LARGE, variant: WidgetVariant.Outlined, ...props }));
}
